<script setup lang="ts">
import CloseIcon from '@/assets/svgs/icons/close.svg'
import ArrowFatLeftIcon from '@/assets/svgs/icons/arrow-fat-left.svg'
import BaseButton from '@/components/base/BaseButton.vue'
import { ref } from 'vue'

defineOptions({
  inheritAttrs: false
})

const { hideCloseButton = false, hasBackNavigation = false } = defineProps<{
  hideCloseButton?: boolean
  hasBackNavigation?: boolean
}>()

const emit = defineEmits(['close', 'back'])

const isOpen = ref(false)

const open = () => {
  isOpen.value = true
}

const close = () => {
  isOpen.value = false
  emit('close')
}

defineExpose({
  open,
  close
})
</script>

<template>
  <Teleport to="body">
    <div>
      <Transition
        enter-active-class="transition-all duration-300 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-all duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div v-if="isOpen" class="fixed inset-0 flex items-center justify-center z-10 bg-cw-dark-alt/80" @click.self="close">
          <Transition
            enter-active-class="transition-all duration-300 ease-out"
            enter-from-class="opacity-0 scale-95"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="transition-all duration-200 ease-in"
            leave-from-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-95"
          >
            <div v-if="isOpen" v-bind="$attrs" class="relative w-[45.8%] min-w-72 max-w-max bg-cw-dark rounded-[13px] px-9 md:px-10 pt-8 md:pt-8 pb-8 md:pb-10 bounce-in">
              <button v-if="!hideCloseButton" class="absolute top-5 right-5" @click="close">
                <CloseIcon class="text-white" />
              </button>
              <slot />
            </div>
          </Transition>
          <div v-if="hasBackNavigation" class="flex z-1 absolute top-[30px] left-[30px]">
            <BaseButton background-color="var(--color-cw-olive)" border-color="#323617" @click="$emit('back')">
              <ArrowFatLeftIcon />
            </BaseButton>
          </div>
        </div>
      </Transition>
    </div>
  </Teleport>
</template>
